import { Component, ChangeDetectionStrategy } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "rask-invalid-url",
    templateUrl: "./invalid-url.component.html",
    styleUrls: ["./invalid-url.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslatePipe]
})
export class InvalidUrlComponent {

}
